import { render, staticRenderFns } from "./radio-item.vue?vue&type=template&id=7a8b65e4&scoped=true"
import script from "./radio-item.vue?vue&type=script&lang=js"
export * from "./radio-item.vue?vue&type=script&lang=js"
import style0 from "./radio-item.vue?vue&type=style&index=0&id=7a8b65e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8b65e4",
  null
  
)

export default component.exports